import { FormattedMessage } from 'react-intl';

import { TApplicantCallRequirement } from '../../fundingRequirements.types';
import { RequirementItem } from '../RequirementItem/RequirementItem';

export const ApplicantCall = ({ status }: TApplicantCallRequirement) => {
    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements_v2.type.applicant_call"
                    defaultMessage="Give us a call"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements_v2.time.5_min"
                    defaultMessage="~ 5 Min."
                />
            }
            status={status}
        />
    );
};
